import { CrudViewColumnType } from '../../../../../utils';

export const filterSupportedColumnTypes = [
  CrudViewColumnType.DateTime,
  CrudViewColumnType.Date,
  CrudViewColumnType.Text,
  CrudViewColumnType.Boolean,
  CrudViewColumnType.Rate,
  CrudViewColumnType.Number,
  CrudViewColumnType.Link,
  CrudViewColumnType.Tag,
  CrudViewColumnType.TagList,
  CrudViewColumnType.Icon,
  CrudViewColumnType.Image,
  CrudViewColumnType.Currency,
  CrudViewColumnType.ActionLink,
  CrudViewColumnType.Code,
  CrudViewColumnType.InputTemplate
];
